import React from 'react'
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@carsys/ui'

interface IConfirmOrderModalProps {
  closeModal: () => void
  title: string
  content: string
  onConfirmButtonClick: () => Promise<void>
}

const ConfirmCloseKeyloopModal: React.FC<IConfirmOrderModalProps> = ({ closeModal, title, content, onConfirmButtonClick }) => {
  const { t } = useTranslation()

  const onRemoveButtonClick = async () => {
    await onConfirmButtonClick()
  }

  return (
    <Dialog open>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color='primary' variant='outlined' onClick={closeModal} data-testid='cancel-button'>
          {t('Alert.No')}
        </Button>
        <Button color='primary' variant='contained' onClick={onRemoveButtonClick}>
          {t('Alert.Yes')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmCloseKeyloopModal
